import { render, staticRenderFns } from "./Charges.vue?vue&type=template&id=2fbe4b43&scoped=true&lang=pug"
import script from "./Charges.vue?vue&type=script&lang=js"
export * from "./Charges.vue?vue&type=script&lang=js"
import style0 from "./Charges.vue?vue&type=style&index=0&id=2fbe4b43&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fbe4b43",
  null
  
)

export default component.exports